import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../../stores';
import './style.scss';
import BriefHeader from './components/BriefHeader/BriefHeader.js';
import ClientDetails from './components/ClientDetails/ClientDetails.js';
import TabsNavigation from './components/TabsNavigation/TabsNavigation.js';
import InfoTab from './components/InfoTab/InfoTab.js';
import FinanceTab from './components/FinanceTab/FinanceTab.js';
import ProjectPlanTab from './components/ProjectPlanTab/ProjectPlanTab.js';
import ContractTab from './components/ContractTab/ContractTab.js';
import MeetingsTab from './components/MeetingsTab/MeetingsTab.js';
import MessageModal from './components/MessageModal/MessageModal.js';
import { formatDate, prepareBriefForUpdate } from '../../../utils/sharedFunctions';

import {
    Design_Illustration,
    Digital_Marketing,
    Mobile_Web_Development,
    Photography_Videography,
    Writing_Reporting
} from '../../../constants/skillsCategories';

var mobile = require('is-mobile');

const ViewBrief = observer(({Briefs, setBriefs, project, navigateMainToPage, AllUsers }) => {
    const { briefStore, projectStore, uiStore , userStore } = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [TabSelected, setTabSelected] = useState('Info');
    const [IsMessage, setIsMessage] = useState(false);
    const [IsInfoEdit, setIsInfoEdit] = useState(false);
    const [SelectedBrief, setSelectedBrief] = useState(project);
    const [Leads, setLeads] = useState([]);
    const [Professionals, setProfessionals] = useState([]);
    const [MessageState, setMessageState] = useState({
        type: '',
        message: '',
        title: ''
    });
    const [newDeliverable, setNewDeliverable] = useState('');
    const [AddDataID, setAddDataID] = useState('');
    const [Pro2Remove, setPro2Remove] = useState('');
    const [SelectedProfessional, setSelectedProfessional] = useState({
        fullName: '',
        status: 'Not Assigned',
        id: ''
    });
    const [isSelectedProActive, setIsSelectedProActive] = useState(false);
    const [ExistingDeliverables, setExistingDeliverables] = useState([]);
    const [LinkClicked, setLinkClicked] = useState(false);
    useEffect(() => {
        getExistingDeliverables();
        getProject();
    }, []);
    useEffect(() => {
    setSelectedBrief(project);
}, [project]);

    //#region functions 
    const getProject =async () => {
        uiStore.setLoading(true);
        let selectedProf={};
        try {
            if (!SelectedBrief) return;

            const pro = { ...SelectedBrief };

            if (typeof pro.talentPartner === 'object' && pro.talentPartner !== null) {
                pro.talentPartner['fullName'] = `${pro?.talentPartner?.firstName ?? ''} ${pro?.talentPartner?.lastName ?? ''}`;
            } else if (typeof pro.fulfillmentLead === 'object' && pro.fulfillmentLead !== null) {
                pro.fulfillmentLead['fullName'] = `${pro?.fulfillmentLead?.firstName ?? ''} ${pro?.fulfillmentLead?.lastName ?? ''}`;
                pro.talentPartner = pro.fulfillmentLead;
                pro.briefDescription = pro.description;
                pro.briefTitle = pro.title;
                pro.offering = pro.servicesOffered?.[0] || '';
            }

            if (typeof pro.client === 'object' && pro.client !== null) {
                pro.client.fullName = pro.client.accountType === 'personal' ? `${pro.client.firstName} ${pro.client.lastName}` : pro.client.company;
            }

            let [professionals, leads] = await Promise.all([
                userStore.getUsers("", "PROF", ""),
                userStore.getUsers("", "ADMIN", "")
            ]);

            professionals = professionals.users??[];
            leads = leads.users??[];
            professionals.forEach(item => {
                item.fullName = `${item.firstName || ''} ${item.lastName || ''}`;
            });

            leads.forEach(item => {
                item.fullName = `${item.firstName || ''} ${item.lastName || ''}`;
            });

            if (pro?.brief?.projectPlan) {
                if (!Array.isArray(pro?.brief?.projectPlan)) {
                    pro.brief.projectPlan = [pro?.brief?.projectPlan];
                }
                if (pro.brief.projectPlan[0]) {
                    const plan = pro.brief.projectPlan[0];
                    if (plan.projStartDate?.includes('T')) {
                        plan.projStartDate = plan.projStartDate.split('T')[0];
                    }
                    if (plan.projEndDate?.includes('T')) {
                        plan.projEndDate = plan.projEndDate.split('T')[0];
                    }
                }
            }
            if (pro.contractType) {
                if (pro.contractType === 'once-off' || pro.contractType === 'Once Off' || pro.contractType === 'Once-Off') {
                    pro.contractType = 'Once-Off';
                }
            }
            if (pro.professionalExperienceLevel) {
                if (pro.professionalExperienceLevel === 'Mid - Level') {
                    pro.professionalExperienceLevel = 'Mid-Level';
                }
            }
            if (pro?.brief?.shortlist?.length > 0) {
                pro.brief.shortlist = [... new Set(pro.brief.shortlist)];
                const firstValidProfessional = pro.brief.shortlist.find(item => {
                    if (item.professional && typeof item.professional === 'object') {
                        if (item.status === 'SELECTED') {
                            return item
                        }
                    }
                }) ;
                if (firstValidProfessional) {
                    const fullName = `${firstValidProfessional.professional.firstName || ''} ${firstValidProfessional.professional.lastName || ''}`.trim();
                    selectedProf={
                        fullName: fullName,
                        status: firstValidProfessional.status,
                        id: firstValidProfessional.professional._id || '',
                        email: firstValidProfessional.professional.email || '',
                        firstName: firstValidProfessional.professional.firstName || '',
                        lastName: firstValidProfessional.professional.lastName || '',
                    }
                } else {
                    selectedProf={ fullName: 'Not Assigned', id: '', status: 'Not Assigned' };
                }
            } else if (pro?.shortlist?.length > 0) {
                pro.shortlist = [... new Set(pro.shortlist)];
                const firstValidProfessional = pro.shortlist.find(item => {
                    if (item.professional && typeof item.professional === 'object') {
                        if (item.status === 'SELECTED') {
                            return item
                        }else{
                            return null
                        }
                    }
                }) ;
                if (firstValidProfessional) {
                    const fullName = `${firstValidProfessional.professional.firstName || ''} ${firstValidProfessional.professional.lastName || ''}`.trim();
                    selectedProf={
                        fullName: fullName,
                        status: firstValidProfessional.status,
                        id: firstValidProfessional.professional._id || '',
                        email: firstValidProfessional.professional.email || '',
                        firstName: firstValidProfessional.professional.firstName || '',
                        lastName: firstValidProfessional.professional.lastName || '',
                    }
                } else {
                    selectedProf={ fullName: 'Not Assigned', id: '', status: 'Not Assigned' };
                }
            };

            setSelectedBrief({
                ...pro,
                client: (pro.client && pro.client || ''),
                professionalExperienceLevel: (pro.professionalExperienceLevel && pro.professionalExperienceLevel || '')
            });
            setSelectedProfessional(selectedProf);
            setLeads(leads);
            setProfessionals(professionals);
        } catch (error) {
            uiStore.showNotification('Error loading project data', 'error');
        } finally {
            uiStore.setLoading(false);
        }
    };
    function getExistingDeliverables() {
        let deliverables = [...ExistingDeliverables];
        if (Array.isArray(SelectedBrief.projectPlan) && SelectedBrief.projectPlan.length > 0 && Array.isArray(SelectedBrief.quote) && SelectedBrief.quote.length > 0) {
            SelectedBrief.projectPlan.forEach(element => {
                if (!Object.keys(element).includes('deliverables')) {
                    element['deliverables'] = [];
                };
                if (element.deliverables.length > 0) {
                    if (Array.isArray(element.deliverables) && element.deliverables.length > 0) {
                        element.deliverables.forEach(del_item => {
                            if (typeof del_item === 'object' && del_item.nameOfItem !== undefined && del_item.nameOfItem !== null && del_item.nameOfItem !== '') {

                                for (let i = 0; i < SelectedBrief.quote.length; i++) {
                                    let quoteItem = SelectedBrief.quote[i].billables ?? [];
                                    if (quoteItem.length > 0) {
                                        quoteItem.forEach(quote_item => {
                                            if (quote_item.itemName === del_item.nameOfItem) {
                                                deliverables.push(quote_item.itemName);
                                            };
                                        });
                                    };
                                };
                            };
                        });
                    }
                };
            });
        };
        deliverables = [...new Set(deliverables)];
        setExistingDeliverables(deliverables);
    };
    const handleEditClicked = () => {
        setIsInfoEdit(true);
    };
    function handleFulfilmentStageChange(e) {
        let brief = { ...SelectedBrief };

        if(Object.keys(brief).includes ("brief")){
            brief.brief.projectPlan[0]['fulfillmentStage'] = '';
            brief.brief.projectPlan[0].fulfillmentStage = e.target.value;
        }else{
            if(brief?.projectPlan?.length > 0){
                brief.projectPlan[0]['fulfillmentStage'] = ''
                brief.projectPlan[0].fulfillmentStage = e.target.value;
            }else{
                brief.projectPlan = [{
                    fulfillmentStage: e.target.value
                }]
            }
        };
        
        setSelectedBrief(brief);
        forceUpdate();
    };
    function handleFeeChange(e) {
        let brief = { ...SelectedBrief };
        brief.budgetEstimation = Number(e.target.value);
        setSelectedBrief(brief);
        forceUpdate();
    };
    function handleProjectPaymentChange(e, index) {
        let brief = { ...SelectedBrief };
        const ID = e.currentTarget.id;
        const value = e.target.value;
        if (ID === 'voucher') {
            if (!brief.payments) {
                brief.payments = {
                    voucherId: ''
                };
                brief.payments.voucherId = value;
            } else {
                brief.payments.voucherId = value;
            };
        };
        if (ID === 'voucherbrief') {
            brief.voucherNumber = value;
        };
        if (ID === 'invoice') {
            if (!brief.payments) {
                brief.payments = { invoiceNumbers: [] };
            }
            if (!brief.payments.invoiceNumbers) {
                brief.payments.invoiceNumbers = [];
            }
            brief.payments.invoiceNumbers[index] = value;
        }
        if (ID === 'date') {
            if (!brief.payments) {
                brief.payments = { previousPayments: [] };
            }
            if (!brief.payments.previousPayments) {
                brief.payments.previousPayments = [];
            }
            if (!brief.payments.previousPayments[index]) {
                brief.payments.previousPayments[index] = {};
            }
            brief.payments.previousPayments[index].date = value;
        };
        if (ID === 'amnt') {
            let amntValue = value.replace(/[^\d,]/g, '');
            if (amntValue.includes(',')) {
                const parts = amntValue.split(',');
                if (parts.length > 2 || parts[1].length > 2) {
                    return;
                }
            }
            if (!brief.payments) {
                brief.payments = { previousPayments: [] };
            }
            if (!brief.payments.previousPayments) {
                brief.payments.previousPayments = [];
            }
            if (!brief.payments.previousPayments[index]) {
                brief.payments.previousPayments[index] = {};
            }
            brief.payments.previousPayments[index].amount = amntValue;
        };
        if (ID === 'poNumber') {
            if (!brief.payments) {
                brief.payments = { purchaseOrderNumber: '' };
            }
            if (!brief.payments.purchaseOrderNumber) {
                brief.payments['purchaseOrderNumber'] = '';
            }
            brief.payments.purchaseOrderNumber = value;
        }
        setSelectedBrief(brief);
    };
    function handleMilestoneChange(e) {
        let brief = { ...SelectedBrief };
        if (Object.keys(brief).includes('brief')) {
            if (!Array.isArray(brief.brief.quote)) {
                brief.brief.quote = []
            };
            if (brief.brief.quote.length === 0) {
                brief.brief.quote[0] = { milestone: '' }
            };

            brief.brief.quote[0].milestone = e.target.value;
        } else if (Array.isArray(brief.quote) && brief.quote.length > 0){
            let matchPro = false;
            for (let i = 0; i < brief.quote.length; i++) {
                if (Object.keys(brief?.quote[i]).includes('billables') && Array.isArray(brief?.quote[i].billables) && brief?.quote[i].billables.length > 0) {
                    matchPro = brief?.projectPlan?.[0]?.professional === brief?.quote[i]?.professional;

                    if (matchPro) {
                        brief.quote[i].milestone = e.target.value;
                    }
                }
            };
            if (!matchPro) {
                uiStore.showNotification('Professional quote not found', 'error');
            };
        }else{
            uiStore.showNotification('Quote not found', 'error');
        }
        setSelectedBrief(brief)
    };
    function handleShortlistClick(event) {
        const selectedProfessionalId = event.currentTarget.id;
        const matchingProfessional = SelectedBrief?.brief?.shortlist.find(item =>item?.professional?._id === selectedProfessionalId)
        || SelectedBrief?.shortlist.find(item =>item?.professional?._id === selectedProfessionalId);
        if (typeof matchingProfessional !== 'object') {
            setIsMessage(true);
            setMessageState({
                type: 'error',
                message: 'User currently not available for selection',
                title: 'Error'
            })
            setIsSelectedProActive(false);
            return
        }
        setSelectedProfessional({
            fullName: `${matchingProfessional.professional.firstName} ${matchingProfessional.professional.lastName}`,
            status: matchingProfessional.status,
            id: matchingProfessional.professional._id || ''
        });
        setIsSelectedProActive(false);
    };
    function getAadditionalData(value) {
        let brief = { ...SelectedBrief };
        let selectedProf = { ...SelectedProfessional };

        // Check if the value is an object
        if (typeof value === 'object') {
            brief = value;
            // Filter out skills that do not match the selected service categories
            if (!brief?.serviceCategory?.includes('Design and Illustration') && !brief?.serviceCategory?.includes('Other Services')) {
                if (!Object.keys(brief).includes("brief")){    
                    brief.skillsOfProfessional = brief?.skillsOfProfessional?.filter(item => !Design_Illustration.includes(item));
                }else{
                    if(brief.brief !==null && brief.brief !==undefined){
                        brief.brief.skillsOfProfessional = brief.brief.skillsOfProfessional.filter(item => !Design_Illustration.includes(item));
                    }
                }
            }
            if (!brief?.serviceCategory?.includes('Digital Marketing and Social Media') && !brief?.serviceCategory?.includes('Other Services')) {
                if (!Object.keys(brief).includes("brief")){    
                    brief.skillsOfProfessional = brief.skillsOfProfessional.filter(item => !Digital_Marketing.includes(item));
                }else{
                    if(brief.brief !==null && brief.brief !==undefined){
                        brief.brief.skillsOfProfessional = brief.brief.skillsOfProfessional.filter(item => !Design_Illustration.includes(item));
                    }
                }
            }
            if (!brief?.serviceCategory?.includes('Mobile and Web Development') && !brief?.serviceCategory?.includes('Other Services')) {
                if (!Object.keys(brief).includes("brief")){    
                    brief.skillsOfProfessional = brief.skillsOfProfessional.filter(item => !Mobile_Web_Development.includes(item));
                }else{
                    if(brief.brief !==null && brief.brief !==undefined){
                        brief.brief.skillsOfProfessional = brief.brief.skillsOfProfessional.filter(item => !Design_Illustration.includes(item));
                    }
                }
            }
            if (!brief?.serviceCategory?.includes('Photography and Videography') && !brief?.serviceCategory?.includes('Other Services')) {
                if (!Object.keys(brief).includes("brief")){    
                    brief.skillsOfProfessional = brief.skillsOfProfessional.filter(item => !Photography_Videography.includes(item));
                }else{
                    if(brief.brief !==null && brief.brief !==undefined){
                        brief.brief.skillsOfProfessional = brief.brief.skillsOfProfessional.filter(item => !Design_Illustration.includes(item));
                    }
                }
            }
            if (!brief?.serviceCategory?.includes('Writing Services') && !brief?.serviceCategory?.includes('Other Services')) {
                if (!Object.keys(brief).includes("brief")){    
                    brief.skillsOfProfessional = brief.skillsOfProfessional.filter(item => !Writing_Reporting.includes(item));
                }else{
                    if(brief.brief !==null && brief.brief !==undefined){
                        brief.brief.skillsOfProfessional = brief.brief.skillsOfProfessional.filter(item => !Design_Illustration.includes(item));
                    }
                }
            }
            // If no service category is selected, clear all professional skills
            if (brief?.serviceCategory?.length === 0) {
                if (!Object.keys(brief).includes("brief")){    
                    brief.skillsOfProfessional = [];
                }else{
                    if(brief.brief !==null && brief.brief !==undefined){
                        brief.brief.skillsOfProfessional = brief.brief.skillsOfProfessional.filter(item => !Design_Illustration.includes(item));
                    }
                }
            };
            // Ensure the shortlist contains unique entries
            brief.shortlist = [...new Set(brief.shortlist)];

            // Handle the case where the shortlist is empty
            if (value.shortlist.length === 0) {
                selectedProf = {
                    fullName: '',
                    status: '',
                    id: ''
                };
            } else {
                // Check if the currently selected professional is still in the shortlist
                let isMatchFound = false;
                if (value.shortlist.length > 0) {
                    for (let i = 0; i < value.shortlist.length; i++) {
                        if ( value.shortlist[i].professional !== null && value.shortlist[i].professional !== undefined && value.shortlist[i].professional._id !== "") {
                            if (value.shortlist[i].professional._id === selectedProf.id) {
                                isMatchFound = true;
                                break;
                            }
                        }
                    }
                }

                // If no match is found, reset the selected professional
                if (!isMatchFound) {
                    selectedProf = {
                        fullName: '',
                        status: '',
                        id: ''
                    };
                };
            };
        };
        setSelectedProfessional(selectedProf);
        setSelectedBrief(brief);
    };
    function handleWorkEnv(e) {
        let selectedBrief = { ...SelectedBrief };
        selectedBrief.workingEnvironment = e.target.value;
        setSelectedBrief(selectedBrief);
    };
    function getSkills() {
        let skills = [];
        const serviceCategory = ['Design and Illustration', 'Digital Marketing and Social Media', 'Mobile and Web Development', 'Photography and Videography', 'Writing Services', 'Other Services']

        for (let i = 0; i < serviceCategory.length; i++) {
            if (SelectedBrief.serviceCategory.includes('Design and Illustration')) {
                skills = [...skills, ...Design_Illustration];
            };
            if (SelectedBrief.serviceCategory.includes('Digital Marketing and Social Media')) {
                skills = [...skills, ...Digital_Marketing];
            };
            if (SelectedBrief.serviceCategory.includes('Mobile and Web Development')) {
                skills = [...skills, ...Mobile_Web_Development];
            };
            if (SelectedBrief.serviceCategory.includes('Photography and Videography')) {
                skills = [...skills, ...Photography_Videography];
            };
            if (SelectedBrief.serviceCategory.includes('Writing Services')) {
                skills = [...skills, ...Writing_Reporting];
            };
            if (SelectedBrief.serviceCategory.includes('Other Services')) {
                skills = [];
                skills = [...Writing_Reporting, ...Design_Illustration, ...Digital_Marketing, ...Mobile_Web_Development, ...Photography_Videography];
            };
        };
        return skills;
    };
    function linkClickedFunc() {
        setLinkClicked(true)
    };
    function linkClickedFunc2() {
        setLinkClicked(false)
    };
    function RemoveShortListed(e) {
        setIsMessage(true);
        setPro2Remove(e.currentTarget.id);
        setMessageState({
            message: 'Are you sure you want to remove this professional from the shortlist?',
            type: 'question',
            title: 'Warning'
        });
    };
    const handleCancelEditClicked = () => {
        setIsInfoEdit(false);
    };
    const handleTabClick = (e) => {
        setTabSelected(e);
        setIsInfoEdit(false);
        setIsSelectedProActive(false);
        forceUpdate();
    };
    const handleFinanceValuesChange = (e) => {
        let currId = e.currentTarget.id;
        let brief = SelectedBrief;
        if (currId === 'TotalCost') {
            brief['finance'].amount = e.target.value;
        }
        if (currId === 'CredippleFee') {
            brief['finance'].credippleFee = e.target.value;
        }
        if (currId === 'ServiceFee') {
            brief['finance'].serviceFee = e.target.value;
        };
        if (currId === 'Link') {
            if (!Object.keys(brief).includes('projectPlan')) {
                brief['projectPlan'] = [{
                    'driveLink': e.target.value
                }];
            }
            brief.projectPlan[0].driveLink = e.target.value;
        }
        if (currId === 'Description') {
            SelectedBrief.briefDescription = e.target.value
        }
        if (currId === 'Deliverables') {
            brief.deliverables = e.target.value;
        }
        if (currId === 'WorkingEnvironment') {
            brief['workingEnvironment'] = e.target.value;
        }
        if (currId === 'Location') {
            brief.location = e.target.value;
        }
        if (currId === 'Industry') {
            brief.industry = e.target.value;
        }
        if (currId === 'StartDate') {
            if (Object.keys(brief).includes('projectPlan') && !Object.keys(SelectedBrief).includes("brief") && Array.isArray(brief.projectPlan) && brief.projectPlan.length > 0) {
                brief.projectPlan[0].projStartDate = e.target.value;
            } else if(brief.brief.projectPlan.length>0) {
                brief.brief.projectPlan[0].projStartDate = e.target.value;
                setSelectedBrief(brief.brief.projectPlan);
            }else{
                brief.brief.projectPlan = [{
                    'projStartDate': e.target.value
                }];
            }
        }
        if (currId === 'EndDate') {
            if (Object.keys(brief).includes('projectPlan') && !Object.keys(SelectedBrief).includes("brief") && Array.isArray(brief.projectPlan) && brief.projectPlan.length > 0) {

                brief.projectPlan[0].projEndDate = e.target.value;
            } else if(brief.brief.projectPlan.length>0) {
                brief.brief.projectPlan[0].projEndDate = e.target.value;
            }else{
                brief.brief.projectPlan = [{
                    'projEndDate': e.target.value
                }];
            }
        }
        setSelectedBrief(brief);
        forceUpdate();
    };
    const handleStatusChange = (e) => {
        let brief = SelectedBrief;
        brief.briefStatus = e.target.value;
        setSelectedBrief(brief);
        forceUpdate();
    };
    const handleFulfilmentChange = (e) => {
        
        let brief = SelectedBrief;
        if ( Object.keys(brief).includes('brief')) {
            brief.fullfilmentLead = Leads.filter((item) => item._id === e.target.value)[0];
            brief['fulfillmentLead'] = Leads.filter((item) => item._id === e.target.value)[0];
        } else {
            brief.talentPartner = Leads.filter((item) => item._id === e.target.value)[0];
        };
        setSelectedBrief(brief);
        forceUpdate();
    };
    
    const handleOfferingChange = (e) => {
        let brief = SelectedBrief;
        if (Object.keys(brief).includes('servicesOffered')) {
            if (Array.isArray(brief.servicesOffered)) {
                brief.servicesOffered.unshift(e.target.value);
                brief.servicesOffered = [...new Set(brief.servicesOffered)];
            } else {
                brief.servicesOffered = [e.target.value];
            };
        } else {
            brief.servicesOffered = [e.target.value];
        };

        setSelectedBrief(brief);
        forceUpdate();
    };
    const handleContractTypeChange = (e) => {
        let brief = SelectedBrief;
        brief.contractType = e.target.value;
        setSelectedBrief(brief);
        forceUpdate();
    };
    const handleLevelChange = (e) => {
        let brief = SelectedBrief;
        brief.professionalExperienceLevel = e.target.value;

        setSelectedBrief(brief);
        forceUpdate();
    };
    const handleBackClick = () => {
        navigateMainToPage(false, false);
    };
    const handleSaveChangesClicked = async () => {
        try {
            let brief = { ...SelectedBrief };
            uiStore.setLoading(true);
            if (Array.isArray(brief?.projectPlan) && brief.projectPlan.length > 0) {
                if (Object.keys(brief.projectPlan[0]).includes('professional') && typeof brief.projectPlan[0].professional === 'object') {
                    delete brief.projectPlan[0].professional.briefs
                    delete brief.projectPlan[0].professional.projects
                    brief.projectPlan[0].professional = brief.projectPlan[0].professional._id;
                };
                brief.projectPlan[0]['customer'] = brief.client;
            };
            let briefId = brief._id;
            let updateBrief = {};
            if (Object.keys(brief).includes('brief')) {
                updateBrief = await saveProject(brief);
                if (updateBrief === 'error') {
                    uiStore.showNotification('Failed to update project', 'error');
                    return;
                }else{
                    let projects =[...Briefs]??[];
                    projects = projects.map(item => {
                        if (item._id === updateBrief._id) {
                            return updateBrief
                        }else{
                            return item
                        }
                    })
                    setSelectedBrief(updateBrief)
                    setBriefs(projects)
                    uiStore.showNotification('Project updated successfully', 'success');
                };
            } else {
                brief = prepareBriefForUpdate(brief);
                updateBrief = await briefStore.updateBriefById(briefId, brief);

                if (!updateBrief || updateBrief === 'error') {
                   uiStore.showNotification('Failed to update Brief', 'error');
                    return;
                }else{
                    let allBriefs =[...Briefs]??[];
                    allBriefs = allBriefs.map(item => {
                        if (item._id === briefId) {
                            return updateBrief.response.brief
                        }else{
                            return item
                        }
                    })
                    setSelectedBrief(updateBrief.response.brief)
                    setBriefs(allBriefs)
                    uiStore.showNotification(updateBrief.message, 'success');
                    uiStore.showNotification('Brief updated successfully', 'success');
                };
            };
            setIsInfoEdit(false);
            forceUpdate();
            //navigateMainToPage(false, true);
            
        } catch (e) {
            uiStore.showNotification('Error updating data. Please try again.', 'error');
        } finally {
           uiStore.setLoading(false);
        }
    };
    async function saveProject(brief) {
        const { briefStatus, briefDescription,  fulfillmentLead,fullfilmentLead,   client,  budgetEstimation,  shortlist,  _id} = brief;

        // Assign top-level brief fields
        brief.status = briefStatus;
        brief.description = briefDescription;
        brief.talentPartner = fulfillmentLead;
        brief.fulfillmentLead = fulfillmentLead?._id?? fullfilmentLead?._id??null ;
        brief.fullfilmentLead = fulfillmentLead; // assuming typo in key name is intentional

        // Process client if it's an object
        if (typeof client === 'object') {
            brief.client = client._id;
            delete client.briefs;
            delete client.projects;
        }

        if (brief && typeof brief === 'object') {
            brief.initialBriefId = brief._id || null;
            brief.projectPlan = brief.projectPlan || [{ customer: client }];
            brief.budgetEstimation = budgetEstimation ?? 0;
            brief.briefStatus = briefStatus ?? 'Not Started';

            brief.shortlist = (shortlist ?? []).map(item => ({
                ...item,
                professional: item.professional?._id || item.professional
            }));

           // const ready4UpdateBrief = prepareBriefForUpdate(brief.brief);

           // const updatedBrief = await briefStore.updateBriefById(ready4UpdateBrief._id, ready4UpdateBrief);
             brief['briefId'] = brief?.brief?._id ?? brief?.initialBriefId??null;
        }

        // Create a unique array for serviceCategory
        brief.serviceCategory = [...new Set(brief.typeOfProfessional)];

        // Remove unnecessary fields
        ["briefStatus", "briefDescription", "talentPartner", "offering"].forEach(prop => delete brief[prop]);

        // Update project
        const updateProject = await projectStore.updateProjectById(_id, brief);

        return updateProject?.project??"error";
    };
    const handleAddDeliverable = (e) => {
        let brief = { ...SelectedBrief }
        const trimmedDeliverable = newDeliverable.trim();
        if (!trimmedDeliverable) {
            return;
        };
        let isAvailable = false;
        ExistingDeliverables.forEach((deliverable) => {
            if (deliverable.toLowerCase().trim() === trimmedDeliverable.toLowerCase().trim()) {
                isAvailable = true;
            }
        });
        if (!isAvailable) {
            let DelItem = {
                nameOfItem: newDeliverable,
                disStartDate: '',
                disEndDate: '',
                reverts: 0,
                duration: 0
            };
            if(  Array.isArray(brief?.projectPlan) && brief?.projectPlan?.length > 0){
                if(Array.isArray(brief.projectPlan[0].deliverables)){
                    brief.projectPlan[0].deliverables.push(DelItem);
                }else{
                    brief.projectPlan[0].deliverables = [DelItem];
                }
            }else if (Array.isArray(brief?.brief?.projectPlan) && brief?.brief?.projectPlan?.length > 0){
                if(Array.isArray(brief.brief.projectPlan[0].deliverables)){
                    brief.brief.projectPlan[0].deliverables.push(DelItem);
                }else{
                    brief.brief.projectPlan[0].deliverables = [DelItem];
                }
            }
        } else {
            uiStore.showNotification("Deliverable already exists", "warning")
            return
        };

        setSelectedBrief(brief);
        setNewDeliverable('');
    };
    const handleDeleteDeliverable = (index) => {
        let brief = { ...SelectedBrief };
        if (Array.isArray(brief?.projectPlan) && brief?.projectPlan?.length > 0 && brief?.projectPlan[0]?.deliverables) {
            brief?.projectPlan[0]?.deliverables?.splice(index, 1);
            setSelectedBrief(brief);
            forceUpdate();
        }else if (Array.isArray(brief?.brief?.projectPlan) && brief?.brief?.projectPlan?.length > 0 && brief?.brief?.projectPlan[0].deliverables) {
            brief.brief.projectPlan[0].deliverables.splice(index, 1);
            setSelectedBrief(brief);
            forceUpdate();
        }
    };
    function DeletePro(e) {
        let brief = { ...SelectedBrief };

        if (e) {
            brief.shortlist = brief.shortlist.filter(item => item.professional._id !== Pro2Remove)
        };
        setSelectedBrief(brief);
        setIsMessage(false);
        setSelectedProfessional({
            fullName: '',
            status: 'Not Assigned',
            id: ''
        })
    };
    function getErroRmessage(event) {
        let isMessage = IsMessage;
        let message = { ...MessageState };
        if (event) {
            isMessage = event.status;
            message = {
                type: event.type,
                message: event.message,
                title: event.title
            };
        };
        setIsMessage(isMessage);
        setMessageState(message);
    };
    //#endregion functions
    if (mobile()) {
        return <div></div>;
    } else if (Object.keys(SelectedBrief).length > 0) {
        return (
            <div className='viewSelectedBrief'>
                   {IsMessage && (
                       <MessageModal type={MessageState.type} children={MessageState.message} title={MessageState.title}
                           onConfirm={DeletePro} onCancel={() => setIsMessage(false)} onOkay={() => setIsMessage(false)}
                       />
                   )}

                    
                    <BriefHeader SelectedBrief={SelectedBrief} IsInfoEdit={IsInfoEdit} handleBackClick={handleBackClick}
                        handleEditClicked={handleEditClicked} handleCancelEditClicked={handleCancelEditClicked}
                        handleSaveChangesClicked={handleSaveChangesClicked}
                    />
   
                   <ClientDetails SelectedBrief={SelectedBrief} />
   
                   <TabsNavigation TabSelected={TabSelected} handleTabClick={handleTabClick} SelectedBrief={SelectedBrief}
                       SelectedProfessional={SelectedProfessional} isSelectedProActive={isSelectedProActive}
                       setIsSelectedProActive={setIsSelectedProActive} handleShortlistClick={handleShortlistClick}
                       RemoveShortListed={RemoveShortListed}
                   />
   
                   {TabSelected === 'Info' && (
                       <InfoTab
                           IsInfoEdit={IsInfoEdit} SelectedBrief={SelectedBrief} Leads={Leads} professionals={Professionals}
                           AddDataID={AddDataID} newDeliverable={newDeliverable} ExistingDeliverables={ExistingDeliverables}
                           handleFinanceValuesChange={handleFinanceValuesChange} handleFulfilmentChange={handleFulfilmentChange}
                           setNewDeliverable={setNewDeliverable} handleAddDeliverable={handleAddDeliverable}
                           handleDeleteDeliverable={handleDeleteDeliverable} handleOfferingChange={handleOfferingChange}
                           handleContractTypeChange={handleContractTypeChange} handleLevelChange={handleLevelChange}
                           handleWorkEnv={handleWorkEnv} getAadditionalData={getAadditionalData}
                           getSkills={getSkills} linkClickedFunc={linkClickedFunc} linkClickedFunc2={linkClickedFunc2}
                           LinkClicked={LinkClicked} Message={getErroRmessage}
                       />
                   )}
   
                    {TabSelected === 'Finance' && (
                        <FinanceTab IsInfoEdit={IsInfoEdit} SelectedBrief={SelectedBrief} handleFeeChange={handleFeeChange}
                            handleStatusChange={handleStatusChange} handleFulfilmentStageChange={handleFulfilmentStageChange}
                            handleMilestoneChange={handleMilestoneChange} handleProjectPaymentChange={handleProjectPaymentChange}
                        />
                    )}

                   {TabSelected === 'ProjectPlan' && (
                       <ProjectPlanTab  getUpdated={(brief)=>{setSelectedBrief(brief)}} SelectedProfessional={SelectedProfessional} IsInfoEdit={IsInfoEdit} SelectedBrief={SelectedBrief} />
                   )}
   
                   {TabSelected === 'Contract' && (
                       <ContractTab project={SelectedBrief} />
                   )}
   
                   {TabSelected === 'Meetings' && (
                       <MeetingsTab  SelectedBrief={SelectedBrief} Professionals={Professionals} SelectedProfessional={SelectedProfessional} AllUsers={AllUsers}  />
                   )}
               </div>
           );
        } else {
           return null;
        }
});

export default ViewBrief;